<div class="document-request-dialog-box">
  <div class="document-request-dialog-box__header">
    <h2>{{ "DOCUMENT_REQUEST.MODAL_TITLE" | translate }}</h2>
  </div>

  @if (isLoading) {
    <div class="document-request-dialog-box__loading">
      <app-spinner></app-spinner>
    </div>
  } @else {
    @if (documentRequest) {
      <div class="document-request-dialog-box__content">
        @if (errorMessage) {
          <div class="document-request-dialog-box__error">
            {{ errorMessage }}
          </div>
        }

        @for (item of documentRequest.items; track item.id) {
          <section class="document-request-dialog-box__item">
            <h3>{{ item.name }}</h3>

            @if (item.files?.length) {
              <ul class="document-request-dialog-box__file-list">
                @for (file of item.files; track file.id) {
                  <li>
                    <span>{{ file.original_filename }}</span>
                    <button
                      type="button"
                      class="document-request-dialog-box__remove"
                      (click)="removeFile(file.id)"
                      [disabled]="isFileDeleting(file.id) || isSubmitting"
                    >
                      <img src="assets/svg/del_icon.svg" alt="delete" />
                    </button>
                  </li>
                }
              </ul>
            }

            <div class="document-request-dialog-box__upload">
              <label [attr.for]="'document-request-files-' + item.id">
                {{ "SEND_MESSAGE_DIALOG.ATTACHMENT.ADD_FILE_BUTTON" | translate }}
              </label>
              <input
                [id]="'document-request-files-' + item.id"
                type="file"
                multiple
                accept=".pdf,application/pdf"
                (change)="onFilesSelected(item.id, $event)"
                [disabled]="isItemUploading(item.id) || isSubmitting"
              />
              @if (isItemUploading(item.id)) {
                <span class="document-request-dialog-box__uploading">
                  {{ "DOCUMENT_REQUEST.UPLOADING" | translate }}
                </span>
              }
            </div>

            <div class="document-request-dialog-box__limits">
              <span>{{ "ADD_ATTACHMENT.ONLY_PDF" | translate }}</span>
              <span>{{ "ADD_ATTACHMENT.MAX_FILE_SIZE_10_MB" | translate }}</span>
              <span>{{ "ADD_ATTACHMENT.MAX_FILE_NUMBER" | translate }} 10</span>
              <span>{{ "ADD_ATTACHMENT.MAX_PAGE_NUMBER" | translate }}</span>
            </div>
          </section>
        }

        <div class="document-request-dialog-box__note">
          <label for="document-request-note">{{ "DOCUMENT_REQUEST.CLIENT_NOTE_LABEL" | translate }}</label>
          <textarea
            id="document-request-note"
            [ngModel]="clientNote"
            (ngModelChange)="onClientNoteChange($event)"
            [placeholder]="'DOCUMENT_REQUEST.CLIENT_NOTE_PLACEHOLDER' | translate"
            [disabled]="isSubmitting"
            rows="6"
          ></textarea>
        </div>
      </div>

      <app-button-two
        [btnTextFirst]="'SEND_MESSAGE_DIALOG.BUTTON_CANCEL'"
        [btnTextSecond]="'SEND_MESSAGE_DIALOG.BUTTON_CONFIRM_AND_SEND'"
        (cancelEmitter)="close()"
        (addEmitter)="submitDocumentRequest()"
        [isDisabled]="isSubmitDisabled"
        [isLoading]="isSubmitting"
      ></app-button-two>
    } @else {
      <div class="document-request-dialog-box__empty">
        @if (errorMessage) {
          <div class="document-request-dialog-box__error">
            {{ errorMessage }}
          </div>
        } @else {
          <p>{{ "DOCUMENT_REQUEST.NO_OPEN_REQUEST" | translate }}</p>
        }
        <button class="btn_simple" type="button" (click)="close()">
          {{ "SEND_MESSAGE_DIALOG.BUTTON_CANCEL" | translate }}
        </button>
      </div>
    }
  }
</div>
